import { render, staticRenderFns } from "./OtherLoading.vue?vue&type=template&id=a796540e&scoped=true&"
import script from "./OtherLoading.vue?vue&type=script&lang=js&"
export * from "./OtherLoading.vue?vue&type=script&lang=js&"
import style0 from "./OtherLoading.vue?vue&type=style&index=0&id=a796540e&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a796540e",
  null
  
)

export default component.exports